import { useMemo } from 'react';

import DashboardTitleWithTooltip from 'components/insights/careTransitions/shared/DashboardTitleWithTooltip';
import InsightsTabsFilterBar from 'components/insights/filterBar/InsightsTabsFilterBar';
import { FilterSection } from 'components/shared/filters/FilterSlideout';
import { TabType } from 'components/Tabs';
import { PREDECESSOR_GROUP } from 'constants/filterKeysConstants';
import { useNetworkPerformanceActions, useNetworkPerformanceStore } from 'stores/networkPerformanceStore';

import { filtersForGroupType, getFilterSections } from '../../filters';
import { useNetworkPerformanceContext } from '../NetworkPerformanceContainer';

type Props = {
  tabs: TabType[];
  selectedTab?: TabType;
  onTabClick: (tab: TabType) => void;
};

export default function NetworkPerformanceFilterBar({ tabs, selectedTab, onTabClick }: Props) {
  const { predecessorGroupType } = useNetworkPerformanceContext();
  const selectedGroupType = useNetworkPerformanceStore((state) => state.selectedGroupType);
  const filters = useNetworkPerformanceStore((state) => state.filters);
  const { setSelectedFilters } = useNetworkPerformanceActions();

  const filterSections = useMemo(
    () => getFilterSections(predecessorGroupType, selectedGroupType, PREDECESSOR_GROUP),
    [predecessorGroupType, selectedGroupType]
  );

  const activeFilters = useMemo(
    () => (selectedGroupType ? filtersForGroupType(filters, selectedGroupType, PREDECESSOR_GROUP) : filters),
    [filters, selectedGroupType]
  );

  return (
    <InsightsTabsFilterBar
      title={
        <DashboardTitleWithTooltip
          title='Post Discharge Dashboard'
          tooltipText='SNF discharges only. LTC transitions are not included.'
        />
      }
      gtmPrefix='postDischargeDashboard'
      tabs={tabs}
      selectedTab={selectedTab}
      onTabClick={onTabClick}
      filters={activeFilters}
      filterSections={filterSections as FilterSection[]}
      setSelectedFilters={setSelectedFilters}
    />
  );
}
